import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  authToken: false,
}

export const authenticationSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    authentication: (state, action) =>{
        state.authToken = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { authentication } = authenticationSlice.actions

export default authenticationSlice.reducer